import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { L } from '../../providers/Lokalise'
import { Button } from '../Button/Button'
import breakpoints from '../../../theme/breakpoints'

const ScrollToTopButton: React.FC = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref
) => {
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const onScroll = () => setOffset(window.pageYOffset)
        // clean up code
        window.removeEventListener('scroll', onScroll)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    const scrollToTop = (): void => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    const mainContent = document.getElementById('main-content')
    const viewportHeight = window.innerHeight
    const mainContentOffset = mainContent?.offsetTop
    const mainContentHeight = mainContent?.clientHeight
    const buttonHidden =
        (mainContentOffset && offset < mainContentOffset) ?? true
    const buttonAbsoloute =
        offset + viewportHeight > mainContentOffset + mainContentHeight

    return (
        <Button
            onClick={scrollToTop}
            style={{
                display: 'none',
                position: buttonAbsoloute ? 'absolute' : 'fixed',
                top: buttonAbsoloute
                    ? mainContentOffset + mainContentHeight - 170
                    : 'calc(100dvh - 5rem)',
                right: '1rem',
                transform: buttonHidden
                    ? 'translateX(calc(100% + 2rem))'
                    : 'translateY(0%)',
                transition: 'transform .3s ease-in-out',
                [`@media (min-width: ${breakpoints.Desktop}px)`]: {
                    display: 'block',
                },
            }}
        >
            {L('GENERISK_TIL-TOPPEN_LABEL')}
        </Button>
    )
}

export { ScrollToTopButton }
